import type {Monster} from '../../../generated/types';
import {toMonsterTypeLine} from '../../../components/render-helpers';
import {composeDescription} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

export type MonsterTab = 'features' | 'about';

/** Термины те же, что в блоке параметров на сайте: КБ, ПЗ, КО */
function stats(monster: Monster): string {
	const parts: string[] = [];
	if (monster.ac) parts.push(`Класс Брони ${monster.ac}`);
	if (monster.hp) parts.push(`Пункты здоровья ${monster.hp}`);
	if (monster.cr) parts.push(`Класс Опасности ${monster.cr}`);
	return parts.join(', ');
}

/** «Чудовище Гоблин: Небольшая фея (гоблиноид), Хаотичная Нейтральная. Класс Брони 15, …» */
export function monsterDescription(monster: Monster, tab: MonsterTab = 'features'): string {
	const statsText = stats(monster);
	const lead = [
		`Чудовище ${monster.title}: ${toMonsterTypeLine(monster)}.`,
		statsText && `${statsText}.`,
		tab === 'features' ? 'Блок параметров, действия и особенности.' : 'Описание, среда обитания и логово.',
	]
		.filter(Boolean)
		.join(' ');
	return composeDescription(lead, monster.description);
}

export function monsterOgCard(monster: Monster): OgCardData {
	return {
		label: 'Чудовище',
		title: monster.title,
		originalTitle: monster.originalTitle,
		subtitle: [toMonsterTypeLine(monster), monster.cr && `КО ${monster.cr}`].filter(Boolean).join(' · '),
	};
}
